// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Api from "../../../../core/Api.js";
import * as Buhta_cabinet__Crm from "../../../../models/Crm.js";
import * as Buhta_cabinet__LogoMaker from "../../../molecules/LogoMaker.js";
import * as Buhta_cabinet__Request from "../../../../core/Request.js";
import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function tab_container(active) {
  return Cn.fromList({
    hd: "border-b flex justify-center items-center cursor-pointer",
    tl: {
      hd: active ? "border-links" : "border-gray-main",
      tl: /* [] */ 0
    }
  });
}

const Styles = {
  tab_container: tab_container
};

function HelpChatInfoPanel$PanelHeader(Props) {
  let currentTab = Props.currentTab;
  let setCurrentTab = Props.setCurrentTab;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: Cn.fromList({
              hd: "tab",
              tl: {
                hd: currentTab === /* Client */ 0 ? "text-links" : "text-gray-medium",
                tl: /* [] */ 0
              }
            }),
            children: "клиент"
          }),
          className: tab_container(currentTab === /* Client */ 0),
          onClick: (function (param) {
            Curry._1(setCurrentTab, (function (param) {
              return /* Client */ 0;
            }));
          })
        }),
        className: "flex items-stretch -mt-px space-x-4"
      }),
      JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx("img", {
          src: StaticAsset.src("/static/icons/more.svg")
        }),
        className: "my-4"
      })
    ],
    className: "flex justify-between items-stretch px-6 border-b border-gray-main h-14"
  });
}

const PanelHeader = {
  make: HelpChatInfoPanel$PanelHeader
};

function HelpChatInfoPanel$ClientInfo$Section(Props) {
  let title = Props.title;
  let itemsOpt = Props.items;
  const items = itemsOpt !== undefined ? itemsOpt : /* [] */ 0;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_components__Text.Label.make, {
        className: "text-default-gray",
        children: title
      }),
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(items, (function (index, item) {
          const Key = "section-item#" + String(index);
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: item.icon,
                className: "shrink-0"
              }),
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-gray-medium",
                children: item.name
              }),
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: item.value
              })
            ],
            className: "flex items-center space-x-2"
          }, Key);
        }))),
        className: "grid gap-2 mt-4"
      })
    ],
    className: "mt-8"
  });
}

const Section = {
  make: HelpChatInfoPanel$ClientInfo$Section
};

function HelpChatInfoPanel$ClientInfo(Props) {
  let orgId = Props.orgId;
  const org = Buhta_cabinet__Request.useFetch(Curry._2(Buhta_cabinet__Api.Endpoints.Crm.orgs, orgId, undefined), Buhta_cabinet__Crm.OrgSummary.decode, undefined);
  if (typeof org === "string") {
    return JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  }
  if (org.NAME !== "Data") {
    return "Error: " + org.VAL.message;
  }
  const org$1 = org.VAL;
  const __x = org$1.organts;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__LogoMaker.make, {
            name: org$1.org.name
          }),
          JsxRuntime.jsx(Buhta_components__Text.H3.make, {
            className: "mt-4",
            children: org$1.org.name
          }),
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "mt-1 text-gray-medium",
            children: org$1.org.address
          })
        ],
        className: "flex flex-col items-center"
      }),
      JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo$Section, {
        title: "детали",
        items: {
          hd: {
            icon: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/employee.svg")
            }),
            name: "БИН",
            value: org$1.org.bin
          },
          tl: {
            hd: {
              icon: JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/table.svg")
              }),
              name: "Режим",
              value: Belt__Belt_Option.mapWithDefault(org$1.tax, "-", (function (tax) {
                return tax.mode_text;
              }))
            },
            tl: {
              hd: {
                icon: JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/chashier.svg")
                }),
                name: "НДС",
                value: Belt__Belt_Option.mapWithDefault(org$1.tax, "-", (function (tax) {
                  if (tax.vat) {
                    return "есть";
                  } else {
                    return "нет";
                  }
                }))
              },
              tl: {
                hd: {
                  icon: JsxRuntime.jsxs("svg", {
                    children: [
                      JsxRuntime.jsxs("g", {
                        children: [
                          JsxRuntime.jsx("path", {
                            clipRule: "evenodd",
                            d: "M2.0213 10.1802C1.60709 9.46276 1.8529 8.54538 2.57034 8.13116L12.0966 2.63116C12.8141 2.21695 13.7314 2.46276 14.1457 3.1802L15.1873 4.98442L3.06297 11.9844L2.0213 10.1802ZM2.44658 12.9168C2.4467 12.917 2.44682 12.9172 2.44694 12.9174C2.44706 12.9176 2.44718 12.9179 2.4473 12.9181L4.98861 17.3197C5.67896 18.5155 7.20794 18.9251 8.40367 18.2348L17.93 12.7348C19.1257 12.0444 19.5354 10.5155 18.845 9.31973L16.6106 5.44968L16.3033 4.91743L15.0117 2.6802C14.3213 1.48447 12.7923 1.07478 11.5966 1.76514L2.07034 7.26514C0.874605 7.95549 0.464919 9.48447 1.15527 10.6802L2.44658 12.9168ZM15.6873 5.85044L15.7446 5.94968L17.979 9.81973C18.3932 10.5372 18.1474 11.4546 17.43 11.8688L7.90367 17.3688C7.18623 17.783 6.26885 17.5372 5.85463 16.8197L3.56297 12.8504L15.6873 5.85044Z",
                            fill: "#818C96",
                            fillRule: "evenodd"
                          }),
                          JsxRuntime.jsx("path", {
                            clipRule: "evenodd",
                            d: "M2.0213 10.1802C1.60709 9.46276 1.8529 8.54538 2.57034 8.13116L12.0966 2.63116C12.8141 2.21695 13.7314 2.46276 14.1457 3.1802L15.1873 4.98442L3.06297 11.9844L2.0213 10.1802ZM2.44658 12.9168C2.4467 12.917 2.44682 12.9172 2.44694 12.9174C2.44706 12.9176 2.44718 12.9179 2.4473 12.9181L4.98861 17.3197C5.67896 18.5155 7.20794 18.9251 8.40367 18.2348L17.93 12.7348C19.1257 12.0444 19.5354 10.5155 18.845 9.31973L16.6106 5.44968L16.3033 4.91743L15.0117 2.6802C14.3213 1.48447 12.7923 1.07478 11.5966 1.76514L2.07034 7.26514C0.874605 7.95549 0.464919 9.48447 1.15527 10.6802L2.44658 12.9168ZM15.6873 5.85044L15.7446 5.94968L17.979 9.81973C18.3932 10.5372 18.1474 11.4546 17.43 11.8688L7.90367 17.3688C7.18623 17.783 6.26885 17.5372 5.85463 16.8197L3.56297 12.8504L15.6873 5.85044Z",
                            fill: "#747F88",
                            fillRule: "evenodd"
                          })
                        ],
                        clipPath: "url(#clip0)"
                      }),
                      JsxRuntime.jsx("defs", {
                        children: JsxRuntime.jsx("clipPath", {
                          children: JsxRuntime.jsx("path", {
                            d: "M0 0H20V20H0V0Z",
                            fill: "white"
                          }),
                          id: "clip0"
                        })
                      })
                    ],
                    height: "20",
                    width: "20",
                    fill: "none",
                    viewBox: "0 0 20 20",
                    xmlns: "http://www.w3.org/2000/svg"
                  }),
                  name: "Счет",
                  value: Belt__Belt_Option.mapWithDefault(org$1.checking, "не установлено", (function (checking) {
                    return checking.iban;
                  }))
                },
                tl: {
                  hd: {
                    icon: JsxRuntime.jsx("img", {
                      src: StaticAsset.src("/static/icons/address.svg")
                    }),
                    name: "Адрес",
                    value: org$1.org.address
                  },
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }),
      JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo$Section, {
        title: "директор",
        items: {
          hd: {
            icon: JsxRuntime.jsx("img", {
              className: "w-5 h-5",
              src: StaticAsset.src("/static/icons/user.svg")
            }),
            name: "ФИО",
            value: Belt__Belt_Option.mapWithDefault(org$1.director, "-", (function (director) {
              return director.short_name;
            }))
          },
          tl: {
            hd: {
              icon: JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/phone.svg")
              }),
              name: "Телефон",
              value: Belt__Belt_Option.mapWithDefault(org$1.director, "-", (function (director) {
                return director.phone;
              }))
            },
            tl: {
              hd: {
                icon: JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/mail.svg")
                }),
                name: "Email",
                value: Belt__Belt_Option.mapWithDefault(org$1.director, "-", (function (director) {
                  return director.email;
                }))
              },
              tl: /* [] */ 0
            }
          }
        }
      }),
      JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo$Section, {
        title: "ответственные",
        items: Belt__Belt_List.map(__x, (function (organt) {
          return {
            icon: JsxRuntime.jsx("img", {
              className: "w-5 h-5",
              src: StaticAsset.src("/static/icons/user.svg")
            }),
            name: "Бухгалтер",
            value: organt.last_name + (" " + organt.first_name)
          };
        }))
      })
    ],
    className: "p-6 animate-fadeInRight"
  });
}

const ClientInfo = {
  Section: Section,
  make: HelpChatInfoPanel$ClientInfo
};

function HelpChatInfoPanel(Props) {
  let orgId = Props.orgId;
  const match = React.useState(function () {
    return /* Client */ 0;
  });
  const currentTab = match[0];
  let tmp;
  tmp = currentTab === /* Client */ 0 ? JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo, {
      orgId: orgId
    }) : JsxRuntime.jsx(Buhta_components__Text.H5.make, {
      children: "chat notes"
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(HelpChatInfoPanel$PanelHeader, {
        currentTab: currentTab,
        setCurrentTab: match[1]
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "flex-1 overflow-auto"
      })
    ],
    className: "h-full flex flex-col"
  });
}

const make = HelpChatInfoPanel;

export {
  Styles,
  PanelHeader,
  ClientInfo,
  make,
}
/* Buhta_cabinet__Crm Not a pure module */
